import stripProps from '@/lib/utils/stripProps';
import styled from '@emotion/styled';
import { alpha, IconButton, type IconButtonProps } from '@mui/material';

type CommentActionButtonProps = IconButtonProps & {
  dangerous?: boolean;
};

const CommentActionButton = styled(
  stripProps(IconButton, 'dangerous'),
)<CommentActionButtonProps>(
  {
    marginTop: -6,
    marginBottom: -6,
    padding: 6,
  },
  ({ theme, dangerous }) => {
    if (dangerous) {
      return {
        transition: theme.transitions.create(['color', 'background-color']),
        ':hover, :focus': {
          color: theme.palette.error.main,
          backgroundColor: alpha(theme.palette.error.main, 0.1),
        },
      };
    }
  },
);

export default CommentActionButton;
